import { ButtonColor } from '@vista-digital/occ-ui/src'
import { useEffect, useState } from 'react'
import type { PromptModalProps } from '@/common/modal/prompt/PromptModal'
import { PromptModal } from '@/common/modal/prompt/PromptModal'

export interface AgeRestrictionModalConfirmationProps {
    show: boolean
    displayText: {
        questionMessage: string
        confirmButtonLabel: string
        declineButtonLabel: string
        declineMessage: string
        declineClosedButtonLabel: string
    }
    events: {
        onConfirmButtonClicked?: () => void
        onDeclinedCloseButtonClicked?: () => void
        onDeclinedButtonClicked?: () => void
    }
}

export const AgeRestrictionModalConfirmation = (props: AgeRestrictionModalConfirmationProps) => {
    const { show, displayText, events } = props

    const [showDeclinedContent, setShowDeclinedContent] = useState(false)

    useEffect(() => {
        document.body.classList[show ? 'add' : 'remove']('confirmation-modal-locked')
    }, [show])

    const close = () => {
        events?.onDeclinedCloseButtonClicked?.()
        window.setTimeout(() => {
            // Wait for modal fade animation to finish the hide content.
            setShowDeclinedContent(false)
        }, 500)
    }

    const decline = () => {
        setShowDeclinedContent(true)
        events?.onDeclinedButtonClicked?.()
    }

    const confirm = () => {
        events?.onConfirmButtonClicked?.()
    }

    const promptModalProps: PromptModalProps = {
        show,
        canBeClosed: false,
        title: showDeclinedContent ? displayText.declineMessage : displayText.questionMessage,
        primaryButtonProps: {
            label: showDeclinedContent ? displayText.declineClosedButtonLabel : displayText.confirmButtonLabel,
            onClick: showDeclinedContent ? close : confirm,
        },
        isScreenBlack: true,
    }

    if (!showDeclinedContent) {
        promptModalProps.secondaryButtonProps = {
            label: displayText.declineButtonLabel,
            color: ButtonColor.Primary,
            onClick: decline,
        }
    }

    return <PromptModal {...promptModalProps} />
}
